module.exports = __webpack_public_path__ + "static/media/final-02.7a2dccf5.png";